import {
  put, call, all, takeLatest,
} from 'redux-saga/effects';
import { notification } from 'antd';
import { setPartsReports, setPartsReportFailure } from '../state/action/partsAction';
import { GET_PARTS_REPORTS } from '../state/types';
import fetch from '../services/fetch';
import { BASE_URL } from '../config';

function* getReports({ projectNo }) {
  let status = 0;
  try {
    const projNo = encodeURIComponent(projectNo).replace(/[!'()]/g, escape).replace(/\*/g, '%2A');
    const res = yield fetch(`${BASE_URL}/project/get-parts-ordering-reports?project_numbers=${projNo}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
    if (res.status === 403) {
      status = res.status;
      throw new Error('Unauthorized');
    }
    const response = yield res.json();
    yield put(setPartsReports({ response }));
  } catch (error) {
    yield put(setPartsReportFailure());
    if (status !== 403) {
      notification.error({
        message: 'There was a problem fetching the report details.',
        description: `${error}`,
      });
    }
  }
}

function* partsWatcher() {
  yield takeLatest(GET_PARTS_REPORTS, getReports);
}

function* partsSagas() {
  yield all([
    call(partsWatcher),
  ]);
}

export default partsSagas;
